import { render, staticRenderFns } from "./GlobalControl.vue?vue&type=template&id=f422898a&scoped=true"
import script from "./GlobalControl.vue?vue&type=script&lang=js"
export * from "./GlobalControl.vue?vue&type=script&lang=js"
import style0 from "./GlobalControl.vue?vue&type=style&index=0&id=f422898a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f422898a",
  null
  
)

export default component.exports